import surveyApi from '@/config/surveyApi'
import { request } from '@/tools'

/**
 * 获取问卷详情和答案
 *
 * @param {*} param
 * @returns
 */
const getSurveyAndAnswer = param => {
  return request({
    url: `${surveyApi.surveyAnswer}/`,
    method: 'get',
    data: param,
    opts: {
      showLoading: false
    }
  })
}

/**
 * 获取问卷设置
 *
 * @param {*} param
 * @returns
 */
const getSurveySetting = surveyMainId => {
  return request({
    url: `${surveyApi.surveyAnswer}/${surveyMainId}/setting`,
    method: 'get',
    opts: {
      showLoading: false
    }
  })
}

// aes解密接口 survey模块
const getAesParam = param => {
  return request({
    url: `/api/survey-answer/param/${param}`,
    method: 'get',
    opts: {
      showLoading: false
    }
  })
}

// 获取当前投票结果
const getVotingResult = data => {
  return request({
    url: `${surveyApi.surveyAnswer}/queryVoteNum`,
    method: 'post',
    data,
    opts: {
      showLoading: true
    }
  })
}

// 校验答卷手机号或者身份证
const validCertNoOrMobile = data => {
  return request({
    url: `/survey-answer/validCertNoOrMobile`,
    method: 'post',
    data,
    opts: {
      showLoading: true
    }
  })
}

export {
  getSurveyAndAnswer,
  getSurveySetting,
  getAesParam,
  getVotingResult,
  validCertNoOrMobile
}



// WEBPACK FOOTER //
// ./src/service/survey.js